import Resource from './resource';
import request from "../utils/request";

class SubTopicsCard extends Resource {
    constructor() {
        super('sub_topics_card');
    }

    store(resource) {
        return request({
            url: `/sub_topics_card/store`,
            method: 'post',
            data: resource
        })
    }

    list(resource) {
        return request({
            url: `/sub_topics_card/list`,
            method: 'POST',
            data: resource
        })
    }

    delete(id) {
        return request({
            url: `/sub_topics_card/delete/${id}`,
            method: 'delete',
        })
    }

    update(id, resource) {
        return request({
            url: `/sub_topics_card/update/${id}`,
            method: 'post',
            data: resource
        })
    }

    restore(id) {
        return request({
            url: `/sub_topics_card/restore/${id}`,
            method: 'post',
        })
    }

    show(id) {
        return request({
            url: `/sub_topics_card/show/${id}`,
            method: 'get',
        })
    }

    lookups(resource) {
        return request({
            url: `/sub_topics_card/lookups`,
            method: 'post',
            data: resource
        })
    }
}

export { SubTopicsCard as default };
